<script>
    import Viewer from '../../../../../utils/tui-editor/Viewer.svelte'
    export let source
</script>

<div class="tabs-preview-wrapper">
    {#if source}
        <Viewer {source} />
    {/if}
</div>